/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchises_AchievementsInputs */

const id_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const ms_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const da_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const de_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaften`)
};

const en_us2_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const es_es2_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const es_mx2_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const fil_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Achievement`)
};

const fr_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const it_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati`)
};

const hu_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmények`)
};

const nl_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestaties`)
};

const no_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjoner`)
};

const pl_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięcia`)
};

const pt_br2_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const pt_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const ro_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizări`)
};

const fi_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutukset`)
};

const sv_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestationer`)
};

const vi_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích`)
};

const tr_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımlar`)
};

const cs_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěchy`)
};

const bg_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постижения`)
};

const ru_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижения`)
};

const uk_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнення`)
};

const ar_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنجازات`)
};

const hi_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियाँ`)
};

const th_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จ`)
};

const ja_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績`)
};

const zh_cn2_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const zh_hant1_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const ko_franchises_achievements = /** @type {(inputs: Franchises_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제`)
};

/**
* | output |
* | --- |
* | "Achievements" |
*
* @param {Franchises_AchievementsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const franchises_achievements = /** @type {((inputs?: Franchises_AchievementsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchises_AchievementsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_franchises_achievements(inputs)
	if (locale === "ms") return ms_franchises_achievements(inputs)
	if (locale === "da") return da_franchises_achievements(inputs)
	if (locale === "de") return de_franchises_achievements(inputs)
	if (locale === "en-US") return en_us2_franchises_achievements(inputs)
	if (locale === "es-ES") return es_es2_franchises_achievements(inputs)
	if (locale === "es-MX") return es_mx2_franchises_achievements(inputs)
	if (locale === "fil") return fil_franchises_achievements(inputs)
	if (locale === "fr") return fr_franchises_achievements(inputs)
	if (locale === "it") return it_franchises_achievements(inputs)
	if (locale === "hu") return hu_franchises_achievements(inputs)
	if (locale === "nl") return nl_franchises_achievements(inputs)
	if (locale === "no") return no_franchises_achievements(inputs)
	if (locale === "pl") return pl_franchises_achievements(inputs)
	if (locale === "pt-BR") return pt_br2_franchises_achievements(inputs)
	if (locale === "pt") return pt_franchises_achievements(inputs)
	if (locale === "ro") return ro_franchises_achievements(inputs)
	if (locale === "fi") return fi_franchises_achievements(inputs)
	if (locale === "sv") return sv_franchises_achievements(inputs)
	if (locale === "vi") return vi_franchises_achievements(inputs)
	if (locale === "tr") return tr_franchises_achievements(inputs)
	if (locale === "cs") return cs_franchises_achievements(inputs)
	if (locale === "bg") return bg_franchises_achievements(inputs)
	if (locale === "ru") return ru_franchises_achievements(inputs)
	if (locale === "uk") return uk_franchises_achievements(inputs)
	if (locale === "ar") return ar_franchises_achievements(inputs)
	if (locale === "hi") return hi_franchises_achievements(inputs)
	if (locale === "th") return th_franchises_achievements(inputs)
	if (locale === "ja") return ja_franchises_achievements(inputs)
	if (locale === "zh-CN") return zh_cn2_franchises_achievements(inputs)
	if (locale === "zh-Hant") return zh_hant1_franchises_achievements(inputs)
	return ko_franchises_achievements(inputs)
});
export { franchises_achievements as "franchises.achievements" }